import React from 'react';
import MemoryUpgradeState from 'routes/supercalendar/components/calendar/memory/MemoryUpgradeState';
import styles from './MemoryGroupUpgradeState.module.scss';

export const MemoryGroupUpgradeState: React.FC = () => {
  return (
    <div className={styles.container}>
      <MemoryUpgradeState />
    </div>
  );
};

export default MemoryGroupUpgradeState;
